import React from 'react';
import { Modal, List, Typography, Button, Tag } from 'antd';
import { StarOutlined, StarFilled } from '@ant-design/icons';
import { IRSchedule } from '../types';

interface IRModalProps {
  isVisible: boolean;
  schedules: IRSchedule[];
  watchedCompanies: string[];
  isMobile: boolean;
  onClose: () => void;
  onToggleWatch: (company: string) => void;
}

const IRModal: React.FC<IRModalProps> = ({
  isVisible,
  schedules,
  watchedCompanies,
  isMobile,
  onClose,
  onToggleWatch,
}) => (
  <Modal
    title={`${schedules[0]?.date} IR 일정`}
    open={isVisible}
    onCancel={onClose}
    footer={null}
    width={isMobile ? '90%' : '60%'}
  >
    <List
      dataSource={schedules}
      renderItem={(schedule) => (
        <List.Item
          key={`${schedule.company}-${schedule.time}`}
          style={{
            padding: '12px 0',
            borderBottom: '1px solid #f0f0f0',
          }}
        >
          <div style={{ width: '100%' }}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '8px',
              }}
            >
              <div
                style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
              >
                <Typography.Text strong>{schedule.company}</Typography.Text>
                <Button
                  type="text"
                  icon={
                    watchedCompanies.includes(schedule.company) ? (
                      <StarFilled style={{ color: '#ffd700' }} />
                    ) : (
                      <StarOutlined />
                    )
                  }
                  onClick={() => onToggleWatch(schedule.company)}
                />
              </div>
              <div>
                <Tag color="blue">{schedule.time}</Tag>
                {schedule.type && <Tag>{schedule.type}</Tag>}
              </div>
            </div>
            <Typography.Text>{schedule.title}</Typography.Text>
          </div>
        </List.Item>
      )}
    />
  </Modal>
);

export default IRModal;
